import { Modal } from "@/components/molecules";
import { useJobPostContext, useUserContext } from "@/providers/contexts";
import { useEffect, useState } from "react";
import { JobPost } from "@/types/jobPost";
import { JobCard } from "./JobCard";

interface JobPostDetailsModalProps {
  jobPost: JobPost | null;
  jobPostDetailsModalOpen: boolean;
  loading: boolean;
  error?: string;
  onCloseButtonClick: () => void;
}

export const JobPostDetailsModal = ({
  jobPost,
  jobPostDetailsModalOpen,
  onCloseButtonClick,
  loading,
  error,
}: JobPostDetailsModalProps) => {
  /* --------------------- Hooks --------------------- */
  const { setFlagJobPostModalOpen } = useJobPostContext();

  const {
    isAuthenticated,
    disabledBasicContent,
    disabledProContent,
    toggleSaveJobPost,
    isJobSaved,
    savedJobs,
  } = useUserContext();

  const disabledContent =
    disabledBasicContent || disabledProContent || !isAuthenticated;
  const jobPostId = jobPost?.id ?? 0;

  const [isBookmarked, setIsBookmarked] = useState(isJobSaved(jobPostId));
  const [snackbar, setSnackbar] = useState({
    state: false,
    msg: "",
    severity: "success" as "success" | "error",
  });

  const handleBookmarkClick = () => {
    toggleSaveJobPost(jobPostId);
    setSnackbar({
      state: true,
      msg: isBookmarked
        ? "Job Post removed from bookmarks"
        : "Job Post added to bookmarks",
      severity: "success",
    });
  };

  const handleFlagErrorClick = () => {
    setFlagJobPostModalOpen(true);
  };

  useEffect(() => {
    setIsBookmarked(isJobSaved(jobPostId));
  }, [savedJobs, jobPostId, isJobSaved]);

  return (
    <Modal
      open={jobPostDetailsModalOpen && jobPostId !== undefined}
      componentName="job-post-details"
      header={jobPost?.job_title || ""}
      logoUrl={jobPost?.company.logo_url}
      loading={loading}
      error={error}
      showBookmark
      bookmarked={isBookmarked}
      disableBookmark={disabledContent}
      onBookmarkToggle={handleBookmarkClick}
      onCloseButtonClick={onCloseButtonClick}
      snackbar={{
        ...snackbar,
        onClose: () => setSnackbar(prev => ({ ...prev, state: false })),
      }}
      handleFlagErrorClick={handleFlagErrorClick}
      isJobCard
    >
      {jobPost && <JobCard jobPost={jobPost} />}
    </Modal>
  );
};
